import { Modal as GammaModal, Skeleton } from '@factorialco/deprecated-design-system'

import CrashLogo from 'modules/core/components/CrashLogo'
import ErrorBoundary from 'modules/core/components/ErrorBoundary'
import Form from 'modules/core/components/Form'

type ModalProps = React.ComponentProps<typeof GammaModal>

type Props = Omit<ModalProps, 'Form' | 'ErrorBoundary' | 'errorContent'>

const Modal = (props: Props) => (
  <GammaModal
    {...props}
    Form={Form}
    ErrorBoundary={ErrorBoundary}
    errorContent={<CrashLogo compact />}
  />
)

Modal.Sidebar = function Sidebar(props: Props) {
  return (
    <GammaModal.Sidebar
      {...props}
      Form={Form}
      ErrorBoundary={ErrorBoundary}
      errorContent={<CrashLogo compact />}
    />
  )
}

export const SkeletonModal = () => {
  return (
    <GammaModal
      // TODO: GammaModal should accept an element here so we can render an skeleton.
      //       However, even if we have a type error it works.
      //       We should deprecate this and use factorial-zero modals instead.
      title={(<Skeleton height="s24" />) as unknown as string}
      Form={Form}
      ErrorBoundary={ErrorBoundary}
      errorContent={<CrashLogo compact />}
    >
      <Skeleton height="s300" />
    </GammaModal>
  )
}

export default Modal
